import {
  CreateLogGroupCommand,
  CreateLogStreamCommand,
  PutLogEventsCommand,
  ResourceAlreadyExistsException,
} from '@aws-sdk/client-cloudwatch-logs'

import { client, LOG_GROUP, LOG_STREAM } from './client'

export const ensureLogSetup = async () => {
  // 1. 로그 그룹 생성
  try {
    await client.send(
      new CreateLogGroupCommand({
        logGroupName: LOG_GROUP,
      }),
    )

    console.log('Log group is created:', LOG_GROUP)
  } catch (error) {
    if (!(error instanceof ResourceAlreadyExistsException)) {
      throw error
    }
    // 이미 있으면 무시
  }

  // 2. 로그 스트림 생성
  try {
    await client.send(
      new CreateLogStreamCommand({
        logGroupName: LOG_GROUP,
        logStreamName: LOG_STREAM,
      }),
    )
    console.log('Log stream is created:', LOG_STREAM)
  } catch (error) {
    if (!(error instanceof ResourceAlreadyExistsException)) {
      throw error
    }
    // 이미 있으면 무시
  }
}

export const log = async (data: unknown) => {
  await client.send(
    new PutLogEventsCommand({
      logGroupName: LOG_GROUP,
      logStreamName: LOG_STREAM,
      logEvents: [
        {
          message: JSON.stringify(data),
          timestamp: Date.now(),
        },
      ],
    }),
  )
}
